import {useState} from 'react'
import {BasicBreadcrumbs} from 'src/app/shared/BasicBreadcrumbs'
import {KTCard} from '../../../../_metronic/helpers'
import {Alerts2Context} from './Alerts2Contexts'
import {AlertsTable} from './main/AlertsTable'
import {AlertsTableHeader} from './main/AlertsTableHeader'

const alertsBreadcrumbs = [
  {
    title: 'Configuración',
    path: '/configuracion/alertas',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const Alerts2Pages = () => {
  const [searchTerm, setSearchTerm] = useState('')
  const [currentPage, setCurrentPage] = useState(1)

  return (
    <Alerts2Context.Provider value={{searchTerm, setSearchTerm, currentPage, setCurrentPage}}>
      <BasicBreadcrumbs breadcrumbs={alertsBreadcrumbs} fallbackTitle='Alertas' />
      <KTCard>
        <AlertsTableHeader />
        <AlertsTable />
      </KTCard>
    </Alerts2Context.Provider>
  )
}

export {Alerts2Pages}
